import { render, staticRenderFns } from "./PaymentAccounts.vue?vue&type=template&id=3959ee58"
import script from "./PaymentAccounts.vue?vue&type=script&lang=js"
export * from "./PaymentAccounts.vue?vue&type=script&lang=js"
import style0 from "./PaymentAccounts.vue?vue&type=style&index=0&id=3959ee58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports